module.exports = {
	customers: (state) => state.customers,
	parts: (state) => state.parts,
};
